import { render, staticRenderFns } from "./ChoosePreferredPhotoitem.vue?vue&type=template&id=c20cf5ba&"
import script from "./ChoosePreferredPhotoitem.vue?vue&type=script&lang=js&"
export * from "./ChoosePreferredPhotoitem.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePreferredPhotoitem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports